import { AutoAttribute } from '@/entities/vehicle'

export class AttributeView extends AutoAttribute {

}
